<!-- Content Header (Page header) -->
<section class="content-header">
  <div class="container-fluid">
      <div class="row mb-2">
          <div class="col-sm-6">
              <h1>{{level?.course?.from?.name}}-{{level?.course?.to?.name}} Kursu {{level?.name}} seviye</h1>

              <div style="margin-top:20px;">
                <p><b>Başlık: </b>{{level?.header}}</p>
                <p><b>Açıklama: </b>{{level?.description}}</p>
                <p><b>Sıra No: </b>{{level?.order}}</p>
                <p><b>Renk: </b><span style="width:80px;height:30px;display: inline-block;" [style.background-color]="level?.color">{{level?.color}}</span></p>
                <p><b>Icon: </b><img src="{{level?.iconUrl}}"></p>
                <p><b>Premium: </b>{{level?.isPremium}}</p>
              </div>

          </div>
          <div class="col-sm-6">
              <ol class="breadcrumb float-sm-right">
                  <li class="breadcrumb-item"><a href="/admin">Ana Sayfa</a></li>
                  <li class="breadcrumb-item"><a href="/coursedetail/{{level?.courseId}}">{{level?.course?.from?.name}}-{{level?.course?.to?.name}}</a></li>
                  <li class="breadcrumb-item active">{{level?.name}}</li>
              </ol>
          </div>
      </div>
  </div>
  <!-- /.container-fluid -->
</section>

<!-- Main content -->
<section class="content">
  <!-- Default box -->
  <div class="container-fluid">
      <div class="card">
          <div class="card-header">
              <h3 class="card-title">Aşamalar
                <button class="btn btn-primary pull-right" (click)="openSaveModal()">+Yeni Ekle</button>
                <a class="btn btn-danger pull-right" href="https://cdn.linguwa.com/sablon.xlsx" target="_blank">Excel Şablon</a>
                <input type="file" class="file-input" (change)="upload($event)" #fileUpload>

                <button   class="btn btn-primary pull-right"
                (click)="fileUpload.click()">
                Excel Yükle
              </button>

                <button class="btn btn-success pull-right" [disabled]="startingBatch" (click)="startAiBatch('Question')">
                  <span *ngIf="startingBatch" class="spinner-border spinner-border-sm" role="status"></span>
                  AI Soru Üret (Batch)
                </button>

                <button class="btn btn-outline-success pull-right" style="margin-right: 8px;" [disabled]="startingBatch" (click)="startAiBatch('WordMeanings')">
                  <span *ngIf="startingBatch" class="spinner-border spinner-border-sm" role="status"></span>
                  AI Kelime Anlamı Üret (Batch)
                </button>
              </h3>


          </div>
          <div class="card-body">

            <div *ngIf="loading">
              <h3>Yükleniyor</h3>
            </div>


            <table *ngIf="!loading" class="table table-bordered">
              <thead>
              <tr>
                <th>Id</th>
                <th>Sıra</th>
                <th>İkon</th>
                <th>Aşama</th>
                <th>Açıklama</th>


                <th>İşlemler</th>
              </tr>
              </thead>
              <tbody>
                <tr *ngFor="let lang of level?.phases" >
                  <td>{{lang.id}}</td>
                  <td>{{lang.order}}</td>
                  <td ><img src="{{lang.iconUrl}}" height="30"></td>
                  <td>{{lang.name}}</td>

                  <td>{{lang.description}}</td>



                  <td>
                     <button class="btn btn-icon btn-pure success" (click)="detail(lang.id)"><i class="fa fa-info"></i> </button>
                     |

                     <button class="btn btn-icon btn-pure info" (click)="edit(lang)" title="düzenle"><i class="fa fa-edit"></i> </button>
                     |  <button class="btn btn-icon btn-pure danger" (click)="delete(lang.id)"><i class="fa fa-trash"></i></button></td>

                </tr>
              </tbody>

            </table>




          </div>
          <!-- /.card-body -->
          <div class="card-footer"></div>
          <!-- /.card-footer-->
      </div>
  </div>
  <!-- /.card -->
</section>
<!-- /.content -->
